import { Card, CardBody, Col } from "reactstrap";
import { HorizontalSolidDividerTitle } from "../../../Constants/Constants";
import { HorizontalSolidDividerData, HorizontalSolidDividerSubTitle } from "../../../Data/UiKits/Divider";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const HorizontalSolidDivider = () => {
  return (
    <Col xxl="4" md="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={HorizontalSolidDividerTitle} span={HorizontalSolidDividerSubTitle} />
        <CardBody className="main-divider">
          {HorizontalSolidDividerData.map((item, index) => (
            <div className={`divider-body divider-body-1 divider-${item.color}`} key={index}>
              <div className={`divider-p-${item.color}`}>
                <i className={`fa fa-${item.icon} me-2 txt-${item.color} f-20`} />
                <span className={`txt-${item.color}`}>Primary</span>
              </div>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default HorizontalSolidDivider;
